import { render } from "./AccordionItem.vue?vue&type=template&id=3c1d35e7&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=3c1d35e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1d35e7"]])

export default __exports__